module.exports = __webpack_public_path__ + "img/table-icon.7e657b65.svg";